enum EnvironmentEnum {
  LOCAL = 'local',
  DEV = 'dev',
  QA = 'qa',
  STAGE = 'stage',
  PROD = 'prod',
  PR = 'pr',
}

type EnvironmentEnumType = `${EnvironmentEnum}`;

export const envSwitch = (envOptions: Record<EnvironmentEnum, string>, overrideEnv?: EnvironmentEnumType): string => (
  envOptions[overrideEnv ?? process.env.REACT_APP_DEPLOY_ENV as EnvironmentEnum]
);

export const CORTEX_URL = envSwitch({
  local: 'http://localhost:8000',
  dev: 'https://cortex.bighealthdev.com',
  qa: 'https://cortex.bighealthdev.com',
  pr: 'https://cortex.bighealthdev.com',
  stage: 'https://cortex.bighealthstage.com',
  prod: 'https://cortex.bighealth.com',
});

export const VAF_URL = envSwitch({
  local: 'https://vercel-auth-functions-lower.vercel.app',
  dev: 'https://vercel-auth-functions-lower.vercel.app',
  qa: 'https://vercel-auth-functions-lower.vercel.app',
  pr: 'https://vercel-auth-functions-lower.vercel.app',
  stage: 'https://vercel-auth-functions-stage.vercel.app',
  prod: 'https://vercel-auth-functions-prod.vercel.app',
});

export const SUPABASE_URL = envSwitch({
  local: 'https://aljyqxctcvkjterlcgnp.supabase.co',
  dev: 'https://aljyqxctcvkjterlcgnp.supabase.co',
  qa: 'https://aljyqxctcvkjterlcgnp.supabase.co',
  pr: 'https://aljyqxctcvkjterlcgnp.supabase.co',
  stage: 'https://ngxdbhvvxledqxykuwpr.supabase.co',
  prod: 'https://evwudmabosoioeqpdbii.supabase.co',
});

export const ENTROPY_URL = envSwitch({
  local: 'https://entropy-lower.vercel.app',
  dev: 'https://entropy-lower.vercel.app',
  qa: 'https://entropy-lower.vercel.app',
  pr: 'https://entropy-lower.vercel.app',
  stage: 'https://entropy-stage.vercel.app',
  prod: 'https://entropy-prod.vercel.app',
});

/**
 * Canopy web origin per environment; empty means no web handoff there. A function so tests can
 * vary `REACT_APP_DEPLOY_ENV`. VAF keeps its own list and never reads this one.
 */
export const canopyWebOrigin = (): string => envSwitch({
  local: 'http://localhost:3000',
  dev: 'https://canopy-sleepio-next.vercel.app',
  qa: 'https://canopy-sleepio-next.vercel.app',
  pr: 'https://canopy-sleepio-next.vercel.app',
  stage: '',
  prod: '',
});
